import {
  ROUTE_CLIENTS,
  ROUTE_CLIENTS_RELATIONSHIP_REVIEW,
  ROUTE_USERS_BAMBOO_PROFILE,
} from "./constants";

export const resetScrollY = (route: string) => {
  // reset clientScrollY if user navigate outside client info tabs
  if (
    !route.includes("/clients") ||
    route.startsWith("/clients/reports/") ||
    route === ROUTE_CLIENTS_RELATIONSHIP_REVIEW
  )
    localStorage.removeItem("clientScrollY");
  // reset relationshipScrollY if user navigate outside client info tabs
  if (
    !route.includes("/clients") ||
    route.startsWith("/clients/reports/") ||
    route === ROUTE_CLIENTS
  )
    localStorage.removeItem("relationshipScrollY");
  // reset userScrollY if user navigate outside client info tabs
  if (!route.includes("/users") || route === ROUTE_USERS_BAMBOO_PROFILE)
    localStorage.removeItem("userScrollY");
};
